export default __webpack_public_path__ + "images/PL.27b6cba.png";